// ADR 2.10.26q §3 — the slot telemetry reads the wasm's last panic through.
//
// The wasm is usually instantiated *before* Sentry is constructed (a lazy
// `import('@sentry/react')` behind consent, ADR 6.9.26c), so the loader cannot
// hand anything to Sentry directly. It publishes here instead, after a
// successful init, and `telemetry/wasmFrames.ts` reads whenever an event needs
// it — whichever of the two arrives first.
//
// **This module imports nothing.** Telemetry is on the boot graph; the facade
// (`./index`) awaits the wasm at module scope and the glue (`./generated/*`)
// is the wasm. A reader passed in as a value is the whole trick: telemetry can
// call `takeLastPanic` without ever importing the module that defines it.
// `bootGraph.test.ts` pins that this file reaches nothing but itself.
//
// §4's debug-image slot (the module's `build_id`) would sit beside this one.
// It is deferred with §2, by §1's measurement — see the ADR.

/** The glue's `takeLastPanic`: the last panic's `message @ file:line`, once. */
export type PanicReader = () => string | null | undefined

let panicReader: PanicReader | null = null

/** Called by `wasm/index.ts` once the module is instantiated; `null` clears it. */
export function registerPanicReader(reader: PanicReader | null): void {
  panicReader = reader
}

/**
 * The last panic, or `null` when there is none or no module has registered.
 * May throw — whether an export still answers after a trap depends on what the
 * panic interrupted — so the caller guards it.
 */
export function readLastPanic(): string | null {
  return panicReader?.() ?? null
}
